<div class="bmc-sequences__container">
  <p class="bmc-sequences__subtitle" [innerHTML]="getSequenceSubtitle">{{"SEQUENCE.SEQUENCES_SUBTITLE" | translate}}</p>
  <table #dataTable class="bmc-sequences__table"></table>
</div>
